import React, { useEffect, useRef, useState } from "react";
import LanguageContext from "../helper/LanguageContext";
import MaterialIcon from "./MaterialIcon";

export default function ArticleAdminMenu({ onEdit, onDelete }) {
  const { strings } = React.useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onDocClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  const menuLabel = `${strings.edit} / ${strings.delete_label}`;

  return (
    <div className="article-admin-menu" ref={rootRef}>
      <button
        type="button"
        className="kj-btn kj-btn--icon kj-btn--lg kj-btn--neutral"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={menuLabel}
        title={menuLabel}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen((value) => !value);
        }}
      >
        <MaterialIcon icon="more_vert" size={24} weight={300} />
      </button>
      {open && (
        <div className="article-admin-menu-dropdown" role="menu">
          <button
            type="button"
            role="menuitem"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setOpen(false);
              if (onEdit) {
                onEdit();
              }
            }}
          >
            <MaterialIcon icon="edit" size={20} weight={300} />
            <span>{strings.edit}</span>
          </button>
          <button
            type="button"
            role="menuitem"
            className="danger"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setOpen(false);
              if (onDelete) {
                onDelete();
              }
            }}
          >
            <MaterialIcon icon="delete" size={20} weight={300} />
            <span>{strings.delete_label}</span>
          </button>
        </div>
      )}
    </div>
  );
}
